module.exports = __webpack_public_path__ + "html/img/volume3_active.e6cf237f.png";